import React from "react";

import { LIST_SECTION_TITLE } from "@FillInTableContainer/shared/components/TableCreatorListBox/constants/tableCreatorListBox.constants";
import { TargetListType } from "@FillInTableContainer/shared/hooks/useHandleTargetListIndex";

import * as S from "./TableCreatorDictionaryDropdown.style";
import { DictionaryList } from "../../types/tableCreatorDropdown.types";

interface Props {
  dictionaryList: DictionaryList;
  targetListIndex: TargetListType;
  targetItemRef: React.RefObject<HTMLLIElement>;
  handleClickDictionaryItem: (item: string) => void;
  isMultiSelect?: boolean;
  multiSelectCurrentValues?: string[];
  handleClickMultiSelectItem?: (item: string, currentValues: string[]) => void;
}

const TableCreatorDictionaryDropdown = ({
  dictionaryList,
  targetListIndex,
  targetItemRef,
  handleClickDictionaryItem,
  isMultiSelect = false,
  multiSelectCurrentValues = [],
  handleClickMultiSelectItem,
}: Props) => {
  const isDictionary = targetListIndex.key === "DICTIONARY";

  return (
    <S.ListWrapper>
      <S.ListSectionTitle>{LIST_SECTION_TITLE.dictionary}</S.ListSectionTitle>
      {dictionaryList.map(
        ({ key, shellKey: dictionaryShellKey, list, isCategory }) => {
          if (isCategory) {
            return list.map(
              (category, categoryIndex) =>
                !!category.list.length && (
                  <S.ListWrapper>
                    <S.CategorySubTitle>
                      {category.categoryKey}
                    </S.CategorySubTitle>
                    {category.list.map((listItem, listIndex) => (
                      <S.DictionaryItem
                        key={`${key}-${dictionaryShellKey}-${listItem}`}
                        data-dropdown="list-box"
                        onMouseDown={() =>
                          isMultiSelect
                            ? handleClickMultiSelectItem?.(
                                listItem,
                                multiSelectCurrentValues,
                              )
                            : handleClickDictionaryItem(listItem)
                        }
                        $isTarget={
                          isDictionary &&
                          categoryIndex === targetListIndex.categoryIndex &&
                          listIndex === targetListIndex.listIndex
                        }
                        $isCategory
                        $isSelected={
                          isMultiSelect &&
                          multiSelectCurrentValues.includes(listItem)
                        }
                        ref={
                          isDictionary &&
                          categoryIndex === targetListIndex.categoryIndex &&
                          listIndex === targetListIndex.listIndex
                            ? targetItemRef
                            : null
                        }
                      >
                        {listItem}
                      </S.DictionaryItem>
                    ))}
                  </S.ListWrapper>
                ),
            );
          }

          return list.map((listItem, listIndex) => (
            <S.DictionaryItem
              key={`${dictionaryShellKey}-${listItem}`}
              data-dropdown="list-box"
              onMouseDown={() =>
                isMultiSelect
                  ? handleClickMultiSelectItem?.(
                      listItem,
                      multiSelectCurrentValues,
                    )
                  : handleClickDictionaryItem(listItem)
              }
              $isTarget={
                isDictionary && listIndex === targetListIndex.listIndex
              }
              $isSelected={
                isMultiSelect && multiSelectCurrentValues.includes(listItem)
              }
              ref={
                isDictionary && listIndex === targetListIndex.listIndex
                  ? targetItemRef
                  : null
              }
            >
              {listItem}
            </S.DictionaryItem>
          ));
        },
      )}
    </S.ListWrapper>
  );
};

export default TableCreatorDictionaryDropdown;
